import {
  GetApplicationDocument,
  GetApplicationQuery,
  GetApplicationQueryVariables,
  GetApplicationsDocument,
  useDeleteProfileMutation,
} from "@/graphql/types";
import { QueryOptions } from "@apollo/client";
import gql from "graphql-tag";

gql`
  mutation deleteProfile($id: ID!) {
    deleteProfile(profileId: $id)
  }
`;

export default function () {
  const mutation = useDeleteProfileMutation({});

  function call(applicationId: string, profileId: string) {
    mutation.mutate(
      {
        id: profileId,
      },
      {
        refetchQueries: [{ query: GetApplicationsDocument }],
        update: (cache) => {
          const parentQuery: QueryOptions<
            GetApplicationQueryVariables,
            GetApplicationQuery
          > = {
            query: GetApplicationDocument,
            variables: {
              applicationId: applicationId,
            },
          };
          const cachedData = cache.readQuery(parentQuery);
          cache.writeQuery({
            ...parentQuery,
            data: {
              application: {
                ...cachedData?.application,
                profiles:
                  cachedData?.application?.profiles?.filter(
                    (element) => element?.profileId != profileId
                  ) ?? [],
              },
            },
          });
        },
      }
    );
  }

  return {
    ...mutation,
    call,
  };
}
